(function() {

    'use strict';



    var Feat = SAPO.Project.Video.Features;



    var SapoPubVAST = function(zoneId, md, playerTypeIsInterno) {
        var uri = [
            Feat.pageProtocol(),
            '//pub.sapo.pt/vast.php?charset=UTF-8',
            '&zoneid=', zoneId,
            '&playerserver=', location.host,
            '&d=', md.duration,
            '&cpid=', md.author,
            '&playertype=' + (playerTypeIsInterno ? 'INTERNO' : 'EXTERNO'),
            '&player=' + (SAPO.Project.Video._kind === 'VideoNative' ? 'Native' : 'HighEnd'),
            md.tags ? '&kw=' + encodeURIComponent( md.tags.join(',') ) : '',
            '&rnd=' + ( ~~(Math.random() * Math.pow(32, 6)) ).toString(32)
        ].join('');

        return uri;
    };

    SAPO.Project.Video.VAST.SapoPubVAST = SapoPubVAST;

})();
